module.exports = __webpack_public_path__ + "static/media/1.Setup demo project channel.8fe5f227.svg";